// import React, { useState, useEffect } from 'react'
// import { Popover, Button, TextField, Box } from '@mui/material'
// import Autocomplete from '@mui/material/Autocomplete'
// import FilterAltIcon from '@mui/icons-material/FilterAlt'
// import { Column, ColumnFiltersState } from '@tanstack/react-table'
// // import { CustomColumnDef } from "./TableContainer";
// import { CustomColumnDef } from './UsersTypeTable'
// import { useDispatch, useSelector } from 'react-redux'
// import { fetchAllDropdowns } from 'slices/organisations/thunk'
// import { Axios } from 'api/axios'

// interface UsersTypeFilterPopover<TData> {
//   column: Column<TData, unknown>
//   columnDef: CustomColumnDef<TData>
//   columnFilters?: ColumnFiltersState
//   iconColor: string
//   setColumnFilters?: React.Dispatch<React.SetStateAction<ColumnFiltersState>>
//   setColValue?: any
// }

// const UsersTypeFilterPopover = ({
//   column,
//   columnDef,
//   setColumnFilters,
//   iconColor
// }: UsersTypeFilterPopover<any>) => {
//   const filterType = columnDef.filterType

//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
//   const [tempValue, setTempValue] = useState(column?.getFilterValue() || '')
//   const dispatch = useDispatch<any>()
//   const open = Boolean(anchorEl)
//   const [tempDateRange, setTempDateRange] = useState<{
//     from_date: string
//     to_date: string
//   }>({
//     from_date: '',
//     to_date: ''
//   })
//   const [dropdownData, setDropDown] = useState<any>([])

//   useEffect(() => {
//     if (open && filterType === 'dropdown') {
//       dispatch(fetchAllDropdowns())
//     }
//   }, [open, filterType, dispatch])

//   const handleOpen = (e: React.MouseEvent<Element>) => {
//     setAnchorEl(e.currentTarget as HTMLElement)
//   }

//   const handleClose = () => {
//     setAnchorEl(null)
//   }

//   // const handleApply = () => {
//   //   if (!setColumnFilters) return

//   //   setColumnFilters(prev => {
//   //     const filtered = prev.filter(f => f.id !== column.id)
//   //     if (
//   //       dropdownKey === 'created_atDropDown' ||
//   //       dropdownKey === 'updated_atDropDown'
//   //     ) {
//   //       if (tempDateRange?.from_date && tempDateRange?.to_date) {
//   //         return [...filtered, { id: column.id, value: tempDateRange }]
//   //       }
//   //       return filtered
//   //     } else if (
//   //       tempValue !== '' &&
//   //       tempValue !== null &&
//   //       tempValue !== undefined
//   //     ) {
//   //       return [...filtered, { id: column.id, value: tempValue }]
//   //     }
//   //     return filtered
//   //   })

//   //   // setAnchorEl(null)
//   // }

//   const handleApply = () => {
//     if (!setColumnFilters) return

//     setColumnFilters(prev => {
//       const filtered = prev.filter(f => f.id !== column.id)

//       if (isDateFilter) {
//         if (tempDateRange?.from_date && tempDateRange?.to_date) {
//           // Just send YYYY-MM-DD strings (not with T00:00:00 / T23:59:59)
//           return [
//             ...filtered,
//             {
//               id: column.id,
//               value: tempDateRange
//             }
//           ]
//         }
//         return filtered
//       } else if (
//         tempValue !== '' &&
//         tempValue !== null &&
//         tempValue !== undefined
//       ) {
//         return [...filtered, { id: column.id, value: tempValue }]
//       }
//       return filtered
//     })

//     setAnchorEl(null)
//   }

//   const handleClear = () => {
//     setTempValue('')
//     setTempDateRange({ from_date: '', to_date: '' })
//     if (setColumnFilters) {
//       setColumnFilters(prev => prev.filter(f => f.id !== column.id))
//     }
//     setAnchorEl(null)
//   }

//   useEffect(() => {
//     if (open) {
//       setTempValue(column.getFilterValue() || '')
//     }
//   }, [open, column])
//   const fetchFilter = async () => {
//     try {
//       const response = await Axios.get(`/user-types/dropdown/`)
//       setDropDown(response?.data?.data)
//     } catch (error) {
//       console.log(error)
//     }
//   }

//   useEffect(() => {
//     fetchFilter()
//   }, [])

//   const dropdownMap: Record<string, string> = {
//     user_type: 'userTypeDropDown',
//     created_at: 'created_atDropDown',
//     updated_at: 'updated_atDropDown'
//     // ...add more as needed
//   }
//   console.log(dropdownData, 'dropdownData')

//   const dropdownKey = dropdownMap[column.id as string]

//   const options = Array.isArray(dropdownData)
//     ? dropdownData.map((item: any) => ({
//         label: item?.user_type,
//         value: item?.user_type
//       }))
//     : []
//   const isDateFilter =
//     dropdownKey === 'created_atDropDown' || dropdownKey === 'updated_atDropDown'

//   return (
//     <>
//       <FilterAltIcon
//         fontSize='small'
//         onClick={handleOpen}
//         className={column.getIsFiltered() ? 'active-filter-icon' : ''}
//         style={{ cursor: 'pointer', marginLeft: 6, color: iconColor }}
//       />

//       <Popover
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//       >
//         <Box p={2} width={250}>
//           {filterType === 'dropdown' ? (
//             isDateFilter ? (
//               <>
//                 <TextField
//                   label='From'
//                   type='date'
//                   value={tempDateRange?.from_date}
//                   fullWidth
//                   InputLabelProps={{ shrink: true }}
//                   onChange={e =>
//                     setTempDateRange(prev => ({
//                       ...prev,
//                       from_date: e.target.value
//                     }))
//                   }
//                 />
//                 <Box mt={2}>
//                   <TextField
//                     label='To'
//                     type='date'
//                     value={tempDateRange?.to_date}
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     onChange={e =>
//                       setTempDateRange(prev => ({
//                         ...prev,
//                         to_date: e.target.value
//                       }))
//                     }
//                   />
//                 </Box>
//               </>
//             ) : (
//               <Autocomplete
//                 sx={{ width: '100%', textTransform: 'capitalize' }}
//                 size='small'
//                 id='filter-autocomplete'
//                 options={options}
//                 value={options.find(opt => opt.value === tempValue) || null}
//                 getOptionLabel={option => option.label || ''}
//                 isOptionEqualToValue={(option, value) =>
//                   option.value === value.value
//                 }
//                 onChange={(_, newValue) => setTempValue(newValue?.value || '')}
//                 renderInput={params => (
//                   <TextField {...params} variant='outlined' label='Select' />
//                 )}
//                 noOptionsText='No Data Found'
//               />
//             )
//           ) : (
//             <TextField
//               fullWidth
//               label='Search'
//               value={tempValue}
//               onChange={e => setTempValue(e.target.value)}
//               size='small'
//             />
//           )}

//           <Box mt={2} display='flex' justifyContent='flex-end' gap={1}>
//             <Button size='small' variant='outlined' onClick={handleClear}>
//               Cancel
//             </Button>
//             <Button
//               size='small'
//               variant='contained'
//               onClick={handleApply}
//               disabled={
//                 isDateFilter &&
//                 (!tempDateRange?.from_date || !tempDateRange.to_date)
//               }
//             >
//               Apply
//             </Button>
//           </Box>
//         </Box>
//       </Popover>
//     </>
//   )
// }

// export default UsersTypeFilterPopover

import React, { useState, useEffect } from 'react'
import { Popover, Button, TextField, Box } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { Column, ColumnFiltersState } from '@tanstack/react-table'
// import { CustomColumnDef } from './OrganisationTable'
import { CustomColumnDef } from './UsersTypeTable'
import { useDispatch, useSelector } from 'react-redux'
// import { fetchAllDropdowns } from 'slices/UserManagement/organisation/thunk'
import { Axios } from "api/axios";

interface UsersTypeFilterPopover<TData> {
  column: Column<TData, unknown>
  columnDef: CustomColumnDef<TData>
  columnFilters?: ColumnFiltersState
  setColumnFilters?: React.Dispatch<React.SetStateAction<ColumnFiltersState>>
  setColValue?: any
  iconColor: string
}

const UsersTypeFilterPopover = ({
  column,
  columnDef,
  setColumnFilters,
  iconColor
}: UsersTypeFilterPopover<any>) => {
  const filterType = columnDef.filterType

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [tempValue, setTempValue] = useState(column?.getFilterValue() || '')
  const [tempDateRange, setTempDateRange] = useState<{
    from_date: string
    to_date: string
  }>({ from_date: '', to_date: '' })
  const [dropDown, setDropDown] = useState<any[]>([])


  const dispatch = useDispatch<any>()
  const open = Boolean(anchorEl)

  const dropdownMap: Record<string, string> = {
    organization_name: 'orgDropDown',
    industry_type: 'industryTypeDropDown',
    org_city: 'orgCityDropDown',
    org_state: 'orgStateDropDown',
    org_pincode: 'pincodeDropDown',
    created_at: 'created_atDropDown',
    updated_at: 'updated_atDropDown',
    org_country: 'countryDropDown'
  }

  const dropdownKey = dropdownMap[column.id as string]
  const isDateFilter =
    dropdownKey === 'created_atDropDown' || dropdownKey === 'updated_atDropDown'

  const dropdownData = useSelector(
    (state: any) => state.Organisations[dropdownKey] || []
  )
 const options = Array.isArray(dropDown)
  ? dropDown.map((item: any) => ({ label: item.user_type, value: item.user_type }))
  : []


 
useEffect(() => {
  const fetchFilter = async () => {
    try {
      const response = await Axios.get(`/user-types/dropdown/`)
      const options = response?.data?.data || []
      setDropDown(options)
    } catch (error) {
      console.error('Dropdown fetch error', error)
    }
  }
  fetchFilter()
}, [])


  // useEffect(() => {
  //   if (open && filterType === 'dropdown') {
  //     dispatch(fetchAllDropdowns())
  //   }
  // }, [open, filterType, dispatch])

  const handleOpen = (e: React.MouseEvent<Element>) => {
    setAnchorEl(e.currentTarget as HTMLElement)
  }

  const handleClose = () => {
    setAnchorEl(null)
  } 
  const handleClear = () => {
    setTempValue('')
    setTempDateRange({ from_date: '', to_date: '' })
    if (setColumnFilters) {
      setColumnFilters(prev => prev.filter(f => f.id !== column.id))
    }
    setAnchorEl(null)
  }

  const handleApply = () => {
    if (!setColumnFilters) return

    setColumnFilters(prev => {
      const filtered = prev.filter(f => f.id !== column.id)

      if (isDateFilter) {
        if (tempDateRange?.from_date && tempDateRange?.to_date) {
          // Just send YYYY-MM-DD strings (not with T00:00:00 / T23:59:59)
          return [
            ...filtered,
            {
              id: column.id,
              value: tempDateRange
            }
          ]
        }
        return filtered
      } else if (
        tempValue !== '' &&
        tempValue !== null &&
        tempValue !== undefined
      ) {
        return [...filtered, { id: column.id, value: tempValue }]
      }
      return filtered
    })

    setAnchorEl(null)
  }

  useEffect(() => {
    if (open) {
      const val: any = column.getFilterValue()
      setTempValue(val || '')
      if (isDateFilter && typeof val === 'object') {
        setTempDateRange({
          from_date: val?.from_date?.substring(0, 10) || '',
          to_date: val?.to_date?.substring(0, 10) || ''
        })
      }
    }
  }, [open, column, isDateFilter])

 

  return (
    <>
      <FilterAltIcon
        fontSize='small'
        onClick={handleOpen}
        className={column.getIsFiltered() ? 'active-filter-icon' : ''}
        style={{ cursor: 'pointer', marginLeft: 6, color: iconColor }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box p={2} width={250}>
          {filterType === 'dropdown' ? (
            isDateFilter ? (
              <>
                <TextField
                  label='From'
                  type='date'
                  value={tempDateRange?.from_date}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={e =>
                    setTempDateRange(prev => ({
                      ...prev,
                      from_date: e.target.value
                    }))
                  }
                />
                <Box mt={2}>
                  <TextField
                    label='To'
                    type='date'
                    value={tempDateRange?.to_date}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    onChange={e =>
                      setTempDateRange(prev => ({
                        ...prev,
                        to_date: e.target.value
                      }))
                    }
                  />
                </Box>
              </>
            ) : (
              <Autocomplete
                sx={{ width: '100%', textTransform: 'capitalize' }}
                size='small'
                id='filter-autocomplete'
                options={options}
                value={options.find(opt => opt.value === tempValue) || null}
                getOptionLabel={option => option.label || ''}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue) => setTempValue(newValue?.value || '')}
                renderInput={params => (
                  <TextField {...params} variant='outlined' label='Select' />
                )}
                noOptionsText='No Data Found'
              />
            )
          ) : (
            <TextField
              fullWidth
              label='Search'
              value={tempValue}
              onChange={e => setTempValue(e.target.value)}
              size='small'
            />
          )}

          <Box mt={2} display='flex' justifyContent='flex-end' gap={1}>
            <Button size='small' variant='outlined' onClick={handleClear}>
              Cancel
            </Button>
            <Button
              size='small'
              variant='contained'
              onClick={handleApply}
              disabled={
                isDateFilter &&
                (!tempDateRange?.from_date || !tempDateRange.to_date)
              }
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  )
}

export default UsersTypeFilterPopover
